import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b58bb71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable" }
const _hoisted_2 = ["value", "type", "placeholder", "required", "disabled", "data-type"]
const _hoisted_3 = {
  key: 0,
  type: "button",
  class: "editable__button button button-sm button-dark"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 5C8 4.44772 8.44772 4 9 4H27C27.5523 4 28 4.44772 28 5V23C28 23.5523 27.5523 24 27 24C26.4477 24 26 23.5523 26 23V6H9C8.44772 6 8 5.55228 8 5Z",
  fill: "#2FF77A"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 9C4 8.44772 4.44772 8 5 8H23C23.5523 8 24 8.44772 24 9V27C24 27.5523 23.5523 28 23 28H5C4.44772 28 4 27.5523 4 27V9ZM6 10V26H22V10H6Z",
  fill: "#2FF77A"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "data-v-4f4b991f": "",
  d: "M22.1928 2.77125C21.8641 2.45373 21.4551 2.22248 21.0055 2.09986C20.5558 1.97723 20.0806 1.96737 19.6258 2.07123L4.95715 5.02005C4.1124 5.13063 3.31678 5.46411 2.65987 5.98294C2.00296 6.50177 1.51087 7.18535 1.23901 7.95668C0.967144 8.72802 0.92631 9.55648 1.1211 10.3488C1.3159 11.1411 1.73858 11.8657 2.34156 12.4411L3.9166 13.9435C4.00185 14.0249 4.06945 14.1214 4.11554 14.2278C4.16164 14.3341 4.18531 14.448 4.18522 14.563V17.3351C4.18724 17.7249 4.28125 18.1092 4.46025 18.4595L4.45292 18.4656L4.47676 18.4884C4.74539 19.0039 5.18413 19.4208 5.72542 19.6749L5.74926 19.6977L5.75568 19.6907C6.12272 19.8615 6.52538 19.9512 6.93375 19.9532H9.83813C10.0811 19.953 10.3143 20.0449 10.4863 20.2087L12.0604 21.7111C12.4826 22.1185 12.9851 22.4422 13.539 22.6634C14.0929 22.8846 14.6871 22.999 15.2875 23C15.7879 22.9994 16.2848 22.9214 16.759 22.769C17.5597 22.518 18.2711 22.0585 18.8128 21.4422C19.3545 20.8259 19.705 20.0774 19.8247 19.2812L22.9189 5.25018C23.0333 4.81236 23.0266 4.35365 22.8993 3.91907C22.772 3.48448 22.5285 3.08894 22.1928 2.77125ZM5.21477 12.708L3.63881 11.2056C3.27184 10.8638 3.01464 10.4291 2.89739 9.95269C2.78015 9.47625 2.80773 8.97777 2.97689 8.51577C3.1409 8.04179 3.44409 7.62274 3.8504 7.30847C4.25672 6.99419 4.74905 6.79791 5.26886 6.74297L19.7917 3.82477L6.01696 16.9737V14.563C6.01835 14.2186 5.94817 13.8773 5.81047 13.5589C5.67278 13.2404 5.47031 12.9512 5.21477 12.708ZM18.0232 18.9819C17.9528 19.4652 17.7427 19.9202 17.4164 20.2959C17.0901 20.6715 16.6606 20.9529 16.176 21.1085C15.6914 21.2641 15.171 21.2877 14.6732 21.1767C14.1754 21.0656 13.7198 20.8244 13.3577 20.4799L11.7808 18.9749C11.5263 18.7306 11.2235 18.537 10.8901 18.4051C10.5566 18.2732 10.1991 18.2058 9.83813 18.2066H7.31238L21.089 5.06205L18.0232 18.9819Z",
  fill: "#2FF77A"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 3,
  class: "editable__icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.1894 2.72768C12.0389 2.63048 11.8415 2.65135 11.7142 2.77919L3.01238 11.5192C2.81389 11.7186 2.79143 11.7468 2.77682 11.7704C2.75554 11.8047 2.73954 11.8421 2.72942 11.8814C2.72241 11.9087 2.71753 11.9449 2.71058 12.2267L2.68331 13.3316L3.81884 13.3334C4.11039 13.3339 4.14683 13.3296 4.17383 13.3231C4.21371 13.3136 4.25193 13.2977 4.28707 13.2761C4.31109 13.2613 4.34023 13.2382 4.54631 13.0312L13.1952 4.34432C13.2188 4.32062 13.2222 4.31713 13.2242 4.31504C13.3485 4.18383 13.3691 3.98354 13.2732 3.82899C13.2717 3.82654 13.2691 3.82243 13.2507 3.79441L13.2281 3.76001C13.2281 3.76 13.2281 3.76001 13.2281 3.76001C12.9572 3.34672 12.6033 2.99512 12.1894 2.72768ZM10.7693 1.83845C11.3401 1.26512 12.2331 1.1685 12.9129 1.60777C13.4833 1.97631 13.9705 2.46046 14.3432 3.02897L14.3657 3.06337L14.3689 3.06822C14.382 3.08818 14.3946 3.10734 14.406 3.1258C14.8211 3.79451 14.7336 4.66044 14.1921 5.23205C14.1772 5.24781 14.161 5.26402 14.1442 5.28093L5.49119 13.9719C5.47976 13.9834 5.46837 13.9949 5.457 14.0063C5.30802 14.1564 5.16218 14.3033 4.98542 14.4119C4.8306 14.5071 4.6617 14.5772 4.48494 14.6197C4.28302 14.6681 4.07606 14.6675 3.86514 14.6669C3.84902 14.6668 3.83288 14.6668 3.81671 14.6668L1.99895 14.6639C1.81947 14.6636 1.64769 14.5909 1.52245 14.4624C1.39722 14.3338 1.32912 14.1602 1.33355 13.9807L1.37765 12.1938C1.37804 12.1782 1.3784 12.1627 1.37876 12.1471C1.38355 11.9426 1.38822 11.7432 1.43817 11.5491C1.48192 11.3791 1.55124 11.2167 1.64379 11.0675C1.7495 10.8971 1.89043 10.7559 2.0346 10.6115C2.04556 10.6005 2.05653 10.5895 2.06751 10.5785L10.7693 1.83845Z",
  fill: "#2FF77A"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

import { computed } from 'vue';
import { toast } from 'vue3-toastify';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseEditable',
  props: {
    value: {},
    placeholder: {},
    required: { type: Boolean },
    type: {},
    buttonText: {}
  },
  emits: ["update:value"],
  setup(__props: any, { emit }) {

const props = __props;


const isEditable = computed(
	() =>
		props.type !== 'button' &&
		props.type !== 'text-copy' &&
		props.type !== 'text-share'
);


function onInput(e: Event) {
	if (e.target) emit('update:value', (e.target as HTMLInputElement).value);
}

function copyText() {
	navigator.clipboard
		.writeText(props.value ?? '')
		.then(() => toast.info('Скопировано'));
}
function shareText() {
	const shareData = {
		title: 'Burngram',
		text: props.value ?? ''
	};

	// Web Share API (only HTTPS, locally supported)
	if (navigator.share && navigator.canShare(shareData)) {
		navigator.share(shareData).then(() => toast.info('Успешно поделились'));
	}
	// Clipboard API
	else if (navigator.clipboard) {
		navigator.clipboard
			.writeText(props.value ?? '')
			.then(() => toast.info('Скопировано'));
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "editable__input form__input",
      onInput: onInput,
      value: _ctx.value,
      type: _ctx.type !== 'button' ? _ctx.type : 'text',
      placeholder: _ctx.placeholder,
      required: _ctx.required,
      disabled: !isEditable.value,
      "data-type": _ctx.type
    }, null, 40, _hoisted_2),
    (_ctx.type === 'button' && _ctx.buttonText)
      ? (_openBlock(), _createElementBlock("button", _hoisted_3, _toDisplayString(_ctx.buttonText), 1))
      : (_ctx.type === 'text-copy')
        ? (_openBlock(), _createElementBlock("svg", {
            key: 1,
            class: "editable__copy",
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 32 32",
            fill: "none",
            onClick: copyText
          }, _hoisted_6))
        : (_ctx.type === 'text-share')
          ? (_openBlock(), _createElementBlock("svg", {
              key: 2,
              class: "editable__copy",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: shareText
            }, _hoisted_8))
          : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
  ]))
}
}

})